import type { FaireProductEntity } from "../../entity_types/product";

export const p_u87k44s6vy: FaireProductEntity = {
  token: "p_u87k44s6vy",
  type: "product",
  name: "VILLA CAPRI",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/cee0c192c39a4fabdf778afe7f31653e71af89a2609d7075be7b03f7430edc2d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a789b380ec5a3a928532d26e023f4419c363cd924a7401128fddd821a2ced8c.jpeg",
    "https://cdn.faire.com/fastly/64df23cdefd269ccd30b5697f83b675f8ace16b108124ddc7e0c54d02478fbc5.jpeg",
    "https://cdn.faire.com/fastly/7e6f32323ba7dd84fd1bd9504cd8e672b20f87e10f337f50c14cd51d9752513b.jpeg",
  ],
  priceDollars: 19,
  description:
    "Roam the cove studded coastline of Capri, a sparkling sea of cobalt and endless sky. Bathed in sunlight and seductively slow paced with breathtaking views of inky blue depths and small strips of beach. Stroll along the maze of alleyways giving way to secret views of villas hidden among cliff folds. Wander the piazza, breathing in the scent of fresh local fruits warmed in the sultry summer sun.  \n\nsun ripened fig, apricot, sliced pomelo, blackcurrant, pimento berry\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8 ounces (226g), comes in our signature Italia box.\n\n",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T13:49:26.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
